import { render, staticRenderFns } from "./IconAdjustmentsSolid.vue?vue&type=template&id=4e838616"
import script from "./IconAdjustmentsSolid.vue?vue&type=script&lang=js"
export * from "./IconAdjustmentsSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports